import type { ServerErrorResponse, ServerErrors } from '@/company-portal/add-file/add-file-form-errors.types';
import { computed, reactive } from 'vue';

export const fileSubmissionErrors = reactive<{ validationErrors?: ServerErrorResponse }>({});

export const serverValidationErrors = computed<ServerErrors | undefined>(() => fileSubmissionErrors.validationErrors?.errors);

export const clearServerValidationError = (key: string) => {
    delete serverValidationErrors.value?.[key];
};
